import React from 'react';
import { motion } from 'framer-motion';
export function ProductSection() {
  return <section className="w-full bg-[#FFF8F0] px-4 md:px-6 py-6 md:py-24 text-center" data-id="element-266">
      <div className="max-w-4xl mx-auto" data-id="element-267">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-268">
          <div className="bg-white rounded-2xl shadow-xl p-5 md:p-12 border border-[#F5E6DC]" data-id="element-269">
            <div className="flex flex-col items-center gap-4 md:gap-10 mb-5 md:mb-10" data-id="element-270">
              <div className="flex-shrink-0" data-id="element-271">
                <img src="https://cdn.magicpatterns.com/uploads/1cjiqCaWzdT1n1m1LusJoE/MOCKUP_MAMA.png" alt="Mente Clara, Mamá Facturando — mockup del ebook en tablet y teléfono" className="w-64 md:w-96 rounded-lg shadow-2xl" data-id="element-272" />
              </div>

              <div className="flex-1 max-w-2xl" data-id="element-273">
                <h2 className="font-['Playfair_Display'] text-3xl md:text-5xl font-bold text-[#2D2D2D] mb-3 md:mb-6 leading-tight" data-id="element-274">
                  MENTE CLARA,{' '}
                  <span className="text-[#E8734A]" data-id="element-275">MAMÁ FACTURANDO</span>
                </h2>
                <p className="text-lg md:text-xl text-[#2D2D2D] font-medium mb-3 md:mb-6 leading-relaxed" data-id="element-276">
                  El método de{' '}
                  <span className="text-[#D4A853] font-bold" data-id="element-277">60 segundos</span>{' '}
                  para que tu mente encienda, tu negocio avance y tú{' '}
                  <span className="text-[#E8734A] font-bold" data-id="element-278">
                    no termines fundida
                  </span>{' '}
                  al final del día.
                </p>
              </div>
            </div>

            <div className="bg-[#FFF8F0] rounded-xl p-5 md:p-8 max-w-3xl mx-auto" data-id="element-279">
              <p className="text-base md:text-lg text-[#2D2D2D] leading-relaxed mb-4 md:mb-8" data-id="element-280">
                Un manual práctico de lectura rápida (
                <span className="text-[#D4A853] font-bold" data-id="element-281">30 minutos</span>)
                diseñado específicamente para mamás emprendedoras que no tienen
                tiempo que perder.
              </p>

              <div className="flex flex-wrap justify-center gap-2 md:gap-4 mb-4 md:mb-8" data-id="element-282">
                <span className="bg-white px-4 md:px-5 py-2.5 md:py-3 rounded-full text-sm font-bold text-[#2D2D2D] shadow-sm border border-[#F5E6DC]" data-id="element-283">
                  Sin términos médicos complicados
                </span>
                <span className="bg-white px-4 md:px-5 py-2.5 md:py-3 rounded-full text-sm font-bold text-[#2D2D2D] shadow-sm border border-[#F5E6DC]" data-id="element-284">
                  Sin meditaciones de 20 minutos
                </span>
                <span className="bg-white px-4 md:px-5 py-2.5 md:py-3 rounded-full text-sm font-bold text-[#2D2D2D] shadow-sm border border-[#F5E6DC]" data-id="element-285">
                  Sin suplementos caros
                </span>
              </div>

              <p className="text-xl font-bold text-[#E8734A]" data-id="element-286">
                Solo <span className="text-[#D4A853]" data-id="element-287">3 técnicas físicas</span>{' '}
                de 60 segundos basadas en cómo funciona tu cerebro de verdad.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}